import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const NotificationCircleIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue994'}</MuiIcon>
        );
    })
